import { render, staticRenderFns } from "./BuildingManage.vue?vue&type=template&id=3c4770fc&scoped=true&"
import script from "./BuildingManage.vue?vue&type=script&lang=js&"
export * from "./BuildingManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4770fc",
  null
  
)

export default component.exports